import styled, { css } from 'styled-components';
import { color, layout, space, typography } from 'styled-system';

const TextfieldStyles = styled.input`
  ${space}
  ${typography}
  ${color}
  ${layout}

  font-size: inherit;

  ${props =>
    props.display === undefined &&
    css`
      display: block;
    `};

  appearance: none;
  background-color: ${props => props.theme.colors.white};
  border: 0.0625rem solid ${props => props.theme.colors.inputBorder};
  height: ${props => props.theme.buttonSize.normal};
  line-height: ${props => props.theme.buttonSize.normal};
  transition: 0.2s linear all;

  ${props =>
    props.color === undefined &&
    css`
      color: inherit;
    `};

  ${props =>
    props.noborder &&
    css`
      border-top: none;
      border-left: none;
      border-right: none;
    `};

  ${props =>
    props.noborder === undefined &&
    css`
      padding-left: ${props.theme.space[1]};
      padding-right: ${props.theme.space[1]};
    `};

  ${props =>
    props.width !== undefined &&
    css`
      width: ${props.width}px;
    `}

  ${props =>
    props.fullWidth &&
    css`
      width: 100%;
    `};

  ${props =>
    props.large &&
    css`
      height: ${parseFloat(props.theme.space[2]) * 4}rem;
      padding: 1rem ${props.theme.space[3]} !important;
    `};

  &::placeholder {
    color: ${props => props.theme.colors.gray};
  }

  ${props =>
    props.disabled === true &&
    css`
      opacity: ${props.theme.opacityDisabled};
      pointer-events: none;
    `}

  ${props =>
    props.multiline === true &&
    css`
      height: ${parseFloat(props.theme.space[4]) * 4}rem;
      resize: none;
    `};
`;

export default TextfieldStyles;
